module.exports = __webpack_public_path__ + "img/nexultra-b-active-icon.a8494cf4.svg";